import { render, staticRenderFns } from "./GiftyWhiteIcon.vue?vue&type=template&id=b959fe02&scoped=true&"
import script from "./GiftyWhiteIcon.vue?vue&type=script&lang=js&"
export * from "./GiftyWhiteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b959fe02",
  null
  
)

export default component.exports